var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"link":""},on:{"click":function($event){return _vm.$emit('selectOrganization', _vm.organization)}}},[_c('v-list-item-avatar'),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.organization.label))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.organization.description))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }